import React, { useEffect, useState } from 'react'
import DocumentsListView from './DocumentsListView';
import SearchInput from './SearchInput';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import SkeletonLoder from '../../common/skeletonLoder';
import { fetchApi } from '../../../utils/methods';
import { GetCompanyAdminRewardDocuments, UpdateAdminRewardDocumentDownloadCount, UploadCompanyAdminRewardDocuments } from '../../../redux/constants/apiConstants';
import { RewarDocumentsContainer } from './styles';
import { AdminDeleteIcon, GridViewRewardIcon, ListViewRewardIcon, RecognitionWarningIcon, UploadDocumentIcon, VerticalDotsIcon } from '../../../utils/icons';
import UploadDocumentModal from './UploadDocumentModal';
import { ImageUrl } from '../../../utils/constants';
import CommonModal from '../../common/CommonModal/CommonModal';
import { HeaderRow } from '../../EventDetails/styles';
import { DownAngleV2 } from '../../SocialFeedsV2/styles';
import { Dropdown, DropdownButton } from 'react-bootstrap';
import DocumentsGridCard from './DocumentsGridCard';


const Documents = ({companyInfo}) => {

  const[documentsData, setDocumentsData]=useState([]);
  const [loading, setLoading] = useState(false);
  const [deleteDocLoading, setDeleteDocLoading] = useState(false);
  const [showUploadModal, seSshowUploadModal] = useState(false);
  const [view, setView] = useState('list');
  const[selectedDoc, setSelectedDoc]=useState(null);
  const[openDeleteModal, setopenDeleteModal]=useState(false);
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState("");

  useEffect(()=>{
    fetchDocuments()
  },[])


  const fetchDocuments = async(searchValue = search, sortValue = sort) =>{
    setLoading(true);
    const payload = {
      company_id: companyInfo?.id,
      ...(searchValue && { search: searchValue }),
      ...(sortValue && { sort: sortValue })
    };
    try {
      const companyRewardsData = await fetchApi(GetCompanyAdminRewardDocuments , "POST",payload);
      if(companyRewardsData.status === 'success'){
        setDocumentsData(companyRewardsData?.data?.documents);
        setSelectedDoc(null)
      }else{
        toast.error(companyRewardsData.message);
      }
    } catch (error) {
      toast.error(error);
      
    }finally{
      setLoading(false);
    }
  }

  const downloadDoc = async (doc) => {
    try {
      const response = await fetch(ImageUrl + "/" + doc?.document, { mode: "cors"});
  
      if (!response.ok) {
        throw new Error(`Failed to download file: ${response.statusText}`);
      }
  
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
  
      const downloadLink = document.createElement("a");
      downloadLink.href = url;
      downloadLink.download = doc?.title || "download"; // Fallback filename
      document.body.appendChild(downloadLink);
      downloadLink.click();
  
      // Cleanup
      window.URL.revokeObjectURL(url);
      document.body.removeChild(downloadLink);
      updateDownloadCount(doc)
    } catch (error) {
      window.console.error("Error downloading file:", error);
    }
  };

  const updateDownloadCount = async(doc) =>{
    setLoading(true);
    const payload = {
      document_id: doc?.id
    };
    try {
      const companyRewardsData = await fetchApi(UpdateAdminRewardDocumentDownloadCount , "POST",payload);
      if(companyRewardsData.status === 'success'){
        fetchDocuments();
        // setDocumentsData(companyRewardsData?.data?.documents);
        setSelectedDoc(null)
      }else{
        toast.error(companyRewardsData.message);
      }
    } catch (error) {
      toast.error(error);
      
    }finally{
      setLoading(false);
    }
  }



  const onDelete = async() =>{
    setDeleteDocLoading(true);

    const payload = {document_id: selectedDoc.id}
    try {
      const companyRewardsData = await fetchApi(UploadCompanyAdminRewardDocuments,"DELETE",payload);
      if(companyRewardsData.status === 'success'){
        toast.success(companyRewardsData?.message);
        setopenDeleteModal(false);
        fetchDocuments();
        setSelectedDoc(null)
        // onClose();
      }else{
        toast.error(companyRewardsData?.data?.message);
      }
    } catch (error) {
      toast.error(error);
      
    }finally{
      setDeleteDocLoading(false);
    }
  }
  

  return (
    <>
      <RewarDocumentsContainer>
        <SearchInput placeholder='Search'   onChange={(value) => {setSearch(value);fetchDocuments(value, sort);}}/>
        <div className='icons-container'>
          {view === 'list' && <span className='icons' onClick={()=>setView('grid')}>{ListViewRewardIcon()}</span>}
          {view === 'grid' && <span className='icons' onClick={()=>setView('list')}>{GridViewRewardIcon()}</span>}
          <div className="menu">
            <DownAngleV2  feed padding="0 16px" marginL="-140px">
              <DropdownButton id="deleteTour" title={<VerticalDotsIcon/>} >
                <Dropdown.Item onClick={()=>{setSort("a_z");fetchDocuments(search, "a_z");}}>
                  {("A-Z Order")}
                </Dropdown.Item>
                <Dropdown.Item onClick={()=>{setSort("newest");fetchDocuments(search, "newest");}}>
                  {("Newest")}
                </Dropdown.Item>
                <Dropdown.Item onClick={()=>{setSort("oldest");fetchDocuments(search, "oldest");}}>
                  {("Oldest")}
                </Dropdown.Item>
              </DropdownButton>
            </DownAngleV2>
          </div>
          <span className='icons' onClick={()=>seSshowUploadModal(true)}>{UploadDocumentIcon()}</span>


        </div>
      </RewarDocumentsContainer>
      {loading ?
        <HeaderRow>
          {Array.from({ length: 3 }).map((_, index) => (
            <SkeletonLoder
              key={index}
              width="1248px"
              height="387px"
              style={{ gap: "25px" }}
            />
          ))}
        </HeaderRow> : 
        view === 'grid' ? <div style={{ display: "flex", flexWrap: "wrap"}}>
          {documentsData?.map((doc) => (
            <DocumentsGridCard
              key={doc.id}
              document={doc}
              onEdit={(doc) => {
                seSshowUploadModal(true);
                setSelectedDoc(doc);
              }}
              onDownload={downloadDoc}
              onDelete={(doc) => {
                setopenDeleteModal(true);
                setSelectedDoc(doc);
              }}
            />
          ))}
        </div>
          :<DocumentsListView
            documents={documentsData}
            onEdit={(doc) =>{seSshowUploadModal(true);setSelectedDoc(doc)}}
            onDownload={(doc) => downloadDoc(doc)}
            onDelete={(doc) =>{setopenDeleteModal(true);setSelectedDoc(doc)}}
          />}

      {showUploadModal && <UploadDocumentModal show={showUploadModal} title={'Upload Document'} fetchDocuments={fetchDocuments} companyInfo={companyInfo} onClose={()=>{seSshowUploadModal(false);setSelectedDoc(null)}} selectedDoc={selectedDoc}/>}

      {openDeleteModal && <CommonModal
        show={openDeleteModal}
        icon={RecognitionWarningIcon("#C13D4D")}
        title="Delete Document"
        description="Are you sure you want to delete this Document?"
        subDescription="This action cannot be undone, and the post will be permanently removed from the system."
        onCancel={()=>setopenDeleteModal(false)}
        onConfirm={onDelete}
        cancelText="Cancel"
        confirmButtonText="Delete Permanently"
        buttonIcon={AdminDeleteIcon()}
        confirmButtonWidth="198px"
        modalHeight="244px"
        descriptionColor="#CE7841"
        isFontSize={"16px"}
        isPopupMargin={"-10px 0 0 0"}
        confirmDisabled={deleteDocLoading}
      />
      }
    </>
  )
}

Documents.propTypes = {
  companyInfo: PropTypes.object,
}

export default Documents